import type { LatestOversightAssessmentObligationOversightResultByObligationIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetLatestOversightAssessmentObligationAssessmentResultByObligationIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetLatestOversightAssessmentObligationAssessmentResultByObligationIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetLatestOversightAssessmentObligationAssessmentResultByObligationIdArgs =
  {
    obligationId: string;
  };

export const useGetLatestOversightAssessmentObligationAssessmentResultByObligationId =
  createQueryHook<
    UseGetLatestOversightAssessmentObligationAssessmentResultByObligationIdArgs,
    LatestOversightAssessmentObligationOversightResultByObligationIdResponseRow[],
    GetLatestOversightAssessmentObligationAssessmentResultByObligationIdQuery
  >({
    trpcQueryOptions: (trpc, { obligationId }) =>
      trpc.frontend.assessment.latestOversightAssessmentObligationAssessmentResultByObligationId.queryOptions(
        { obligationId }
      ),
    mapTrpcDataToGraphQL: (data) => ({
      obligation_oversight_result: data,
    }),
    graphqlDocument:
      GetLatestOversightAssessmentObligationAssessmentResultByObligationIdDocument,
    graphqlVariables: ({ obligationId }) => ({ ObligationId: obligationId }),
  });
